import React, { useEffect, useState } from "react";
import EditorDashboardWrapper from "../../../layout/wrapper/EditorDashboardWrapper";
import EditorFilter from "../../../components/EditorFilter/EditorFilter";
import styles from "../../../styles/pages/user/editordashboard/editor-publish-video.module.scss";
import { Box } from "@mui/material";
import EditorPublishTable from "../../../components/EditorPublishTable/EditorPublishTable";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useQuery } from "react-query";
import { editorDashboardPublishpageMutation } from "../../../api/functions/editorDashboard.api";
import ApiLoader from "../../../components/Loaders/ApiLoader";
import { useLocation } from "react-router";

const EditorPublishVideo = () => {
  const [page, setPage] = useState(1);
  const { from, to } = useAppSelector((s) => s.editorPublishVideoSlice);
  const [receivedData, setReceivedData] = useState(null);
  const handleDataFromChild1 = (data) => {
    setReceivedData(data);
    if (data == true) {
      refetchAgain();
    }
  };

  const handlePageChange = (p) => {
    setPage(p);
    handleTriggreFetch();
  };

  const [fetchTrigger, setFetchTrigger] = useState(Date.now());
  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const metadataValue = queryParams.get("metadata_update");

  const { data, isLoading, refetch, isRefetching } = useQuery(
    ["editorPublishVideo", page, receivedData, metadataValue],

    async () => {
      return editorDashboardPublishpageMutation({
        published_videos: true,
        metadata_update: metadataValue ? "yes" : null,
        page: page,
        from: from,
        to: to,
      });
    }
  );

  useEffect(() => {
    refetch();
  }, [fetchTrigger]);
  return (
    <>
      {isLoading ? (
        <ApiLoader loading={isLoading || isRefetching} />
      ) : (
        <EditorDashboardWrapper>
          <Box className={styles.publishedVideoMain}>
            <Box className={styles.publishedVideoFilter}>
              <EditorFilter
                data={data?.data}
                handleTriggreFetch={handleTriggreFetch}
              />
            </Box>
            <Box className={styles.publishVideoTable}>
              <EditorPublishTable
                data={data?.data}
                handlePageChange={handlePageChange}
                page={page}
              />
            </Box>
          </Box>
        </EditorDashboardWrapper>
      )}
    </>
  );
};

export default EditorPublishVideo;
